/**
 * Finds the index of the closest value.
 *
 * @param {Array<number>} values - Array of numbers to search through.
 * @param {number} value - The target value to find the closest match for.
 * @returns {number} The index of the closest value in the array.
 */
export const indexOfClosest = (values: Array<number>, value: number) => {
  if (values.length === 1) return 0;
  const distances = values.map((n) => Math.abs(n - value));
  return distances.indexOf(Math.min(...distances));
};
